import Vue from 'vue'
import Component from '../shared/component'

const PRESETS = {
  shortdate: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  },
  longdate: {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  },
  shorttime: {
    hour: 'numeric',
    minute: 'numeric'
  },
  longtime: {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  }
}

export function assign (target) {
  for (let i = 1, n = arguments.length; i < n; i++) {
    const source = arguments[i]
    const keys = Object.keys(source)

    for (let j = 0, m = keys.length; j < m; j++) {
      const k = keys[j]
      const v = source[k]

      if (v !== undefined && v !== null) {
        target[k] = v
      }
    }
  }

  return target
}

export const Time = Component('v-time', {
  functional: true,
  props: {
    datetime: {
      type: [String, Number, Date],
      required: true
    },
    format: {
      type: String,
      default: null,
      validator (value) {
        return value in PRESETS
      }
    },
    weekday: {
      type: String
    },
    year: {
      type: String
    },
    month: {
      type: String
    },
    day: {
      type: String
    },
    hour: {
      type: String
    },
    minute: {
      type: String
    },
    second: {
      type: String
    }
  },
  render (createElement, {props}) {
    let {datetime, format, ...options} = props

    if (!datetime) {
      return
    }

    if (format in PRESETS) {
      options = assign({}, PRESETS[format], options)
    }

    const date = datetime.constructor === Date
      ? datetime
      : new Date(datetime)

    return createElement(
      'time',
      {
        class: 'time',
        attrs: {
          datetime: date
        }
      },
      [
        date.toLocaleString(Vue.config.locale, options)
      ]
    )
  }
})
